export function cumulativeDelayMinutes(steps = []) {
  return steps.reduce((sum, step) => sum + Number(step.delayMinutes || 0), 0);
}

const SOCIAL_MESSAGING_WINDOW_HOURS = 20;

export function exceedsSocialWindow(steps = []) {
  return cumulativeDelayMinutes(steps) > SOCIAL_MESSAGING_WINDOW_HOURS * 60;
}
